import { render } from "./SchemeCustomize.vue?vue&type=template&id=28f5a876&scoped=true&ts=true"
import script from "./SchemeCustomize.vue?vue&type=script&lang=ts"
export * from "./SchemeCustomize.vue?vue&type=script&lang=ts"

import "./SchemeCustomize.vue?vue&type=style&index=0&id=28f5a876&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f5a876"]])

export default __exports__